import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { ActivatedRoute, Router } from "@angular/router";
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ProformaService } from '../proforma.service';
import { Proforma } from '../proforma';
import { ProformaComponent } from '../proforma/proforma.component';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import * as moment from 'moment';
import { ProformaGeneratesComponent } from '../Proforma-generates/proforma-generates.component';

@Component({
    selector: 'app-proforma-generated-list',
    templateUrl: './proforma-generated-list.component.html',
    styleUrls: ['./proforma-generated-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ProformaGeneratedListComponent implements OnInit {
	constructor(
		private proformaService: ProformaService,
		private alertService: AlertService,
		private messageService: MessageService,
		private route: ActivatedRoute,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.requestProformaId = this.route.snapshot.params['proformaId'];
		this.statuses = proformaService.statuses
		this.visibilities = proformaService.visibilities;
	}



	// data
	@Input() proformaList: any;

	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() updateProformaList: boolean = false;

	proformas: any;
	proforma: Proforma;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = false;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	visibilities:any;

	requestProformaId: any;

	columns: any[] = [
		// { field: 'propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'customAddress', header: 'Address', width: 'auto' },
		{ field: 'preparedDate', header: 'Prepared Date', width: 'auto' },
		{ field: 'createdBy', header: 'Created By', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'visibility', header: 'Visibility', width: 'auto' },
		{ field: 'realtorName', header: 'Realtor', width: 'auto' },
		{ field: 'homeOwner', header: 'Home Owner', width: 'auto' },
		{ field: 'expandYrGrossTtl', header: 'Expand Gross Ttl', width: 'auto' },
		{ field: 'stableYrGrossTtl', header: 'Stable Gross Ttl', width: 'auto' },
		{ field: 'contractYrGrossTtl', header: 'Contract Gross Ttl', width: 'auto' },

	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
			if(this.proformaList != undefined) {
				this.proformaList.forEach(proforma => {
					//For regular proforma dialog
					var subjAdrStreet = proforma.propertyLeadProfile?.subjAdrStreet != undefined ? (proforma.propertyLeadProfile?.subjAdrStreet) : '';
					var subjAdrUnit = proforma.propertyLeadProfile?.subjAdrUnit != undefined ? ('#'+proforma.propertyLeadProfile?.subjAdrUnit) : '';
					var subjAdrCity = proforma.propertyLeadProfile?.subjAdrCity != undefined ? (proforma.propertyLeadProfile?.subjAdrCity + ',') : '';
					var subjAdrState = proforma.propertyLeadProfile?.subjAdrState != undefined ? (proforma.propertyLeadProfile?.subjAdrState) : '';
				
					proforma.customAddress = subjAdrStreet + ' ' + subjAdrUnit + ' ' + 
										subjAdrCity + ' ' + subjAdrState
				});
				this.proformas = this.proformaList;
			}
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	ngOnChanges() {
		this.ngOnInit();
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.proformaId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(proforma: Proforma) {
		try {
			this.formLoading = true;
			this.proformaService.update(proforma)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.proformas.map((proforma, i) => {
							if (proforma.proformaId === res.data.proforma.proformaId) {
								this.proformas[i] = res.data.proforma;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(proforma: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(proforma));

			this.formLoading = true;
			this.proformaService.delete(proforma.proformaId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.proformas.splice(this.proformas.indexOf(proforma), 1);
						this.recordTotal = this.proformas.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Proforma ' + proforma.proformaId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Proforma ' + proforma.proformaId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Generate proformas
		 *
		 */
	onOpenGenerateProformaForm() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Generate Proformas'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ProformaGeneratesComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addProformaCB(data);

				// close the dialogBox
				//dialogRef.close();
			});
	}

	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(proforma: Proforma) {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.maxWidth = "100vw";
		dialogConfig.width = "80vw";
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			proforma: proforma,
			title: 'Edit Proforma'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ProformaComponent, dialogConfig);

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteProformaCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addProformaCB(proforma: Proforma) {
		console.log('Adding Proforma: ' + JSON.stringify(proforma));
		// if we don't have a proformas array yet...
		if (!this.proformas) {
			this.proformas = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.proformas.unshift(proforma);

		// no idea what this is but it is required to update the array
		this.proformas = [...this.proformas];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma ' + proforma.proformaId + ' Added', life: 3000 });
	}

	updateProformaCB(proforma: Proforma) {
		console.log('Updating Proforma: ' + JSON.stringify(proforma));
		let itemIndex = this.proformas.findIndex((item: any) => item.proformaId === proforma.proformaId);
		//proforma.preparedDate = moment(this.proforma.preparedDate).toDate();
		this.proformas[itemIndex] = proforma;

		// no idea what this is but it is required to update the array
		this.proformas = [...this.proformas];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma ' + proforma.proformaId + ' Updated', life: 3000 });
	}

	deleteProformaCB(proforma: Proforma) {
		console.log('Removing Proforma: ' + proforma);
		this.proformas.splice(this.proformas.indexOf(proforma), 1);
		this.recordTotal = this.proformas.length;

		// no idea what this is but it is required to update the array
		this.proformas = [...this.proformas];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma ' + proforma.proformaId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.proformas ? this.first === (this.proformas.length - this.rows) : true; }
	isFirstPage(): boolean { return this.proformas ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(proforma: any) {
		if (proforma?.status != undefined) {
			const status = this.statuses.find((e: any) => e.value == proforma.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	getVisibilityName(proforma: any) {
		if (proforma?.visibility != undefined) {
			const visibility = this.visibilities.find((e: any) => e.value == proforma.visibility);
			return visibility.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}

}
